module.exports = __webpack_public_path__ + "img/icon_submenu5.dd0725e0.svg";